import React, { useState, useRef, useEffect } from "react";
import { LayoutHome } from "../LayoutHome";
import moment from "moment/moment";
import {
  Box,
  Panel,
  SelectPicker,
  Text,
  Modal,
  Message,
  toaster,
  Popover,
  Whisper,
  Checkbox,
  TimePicker,
} from "rsuite";
import { Input, notification, Splitter, Button, Form, InputNumber } from "antd";
import Popup from "reactjs-popup";
import SignatureCanvas from "react-signature-canvas";
import Table from "react-bootstrap/Table";
import {
  getTurnos,
  getHorariosTurno,
  getInsumosSesion,
} from "../Services/SesionHemoServices";
import {
  getVerificaProc,
  getPacientesSesion,
  getDatospaciente,
  getAccesoVascular,
  getDataFiltro,
  getNumSesionesSem,
  getHoraActual,
  iniciaHojaEnf,
  getHojaEnfermeria,
  getFiltroAsignadoSesion,
  saveCampoHoja,
  saveSeguimiento,
  getSeguimientos,
  getExisteAsignacion,
  getValidaCierre,
  getSeguimientosHoja,
  saveVerificaPre,
  saveHoraAplica,
  saveFirmaHojaEnf,
} from "../Services/HojaEnfermeria";
import {
  getAsignacion,
  getFiltrosXInventario,
  saveAsignaFiltro,
} from "../Services/FiltrosServices";
import { soloNumeros } from "../../Utils";
import {
  Check,
  DoorClosed,
  Eraser,
  LucideAArrowDown,
  PlusCircleIcon,
  RefreshCcw,
  Save,
} from "lucide-react";
import { Image } from "react-bootstrap";
import { confApp } from "../../CONF_APP";
import { ModalInsumos } from "./ModalInsumos";

const { TextArea } = Input;

export const HojaEnfermeria = () => {
  const [idNegocio] = useState(JSON.parse(localStorage.getItem("auth")).id);
  const [negocio] = useState(
    JSON.parse(localStorage.getItem("auth")).consultorio,
  );
  const [camposHojaEnf] = useState(
    JSON.parse(localStorage.getItem("auth")).camposHojaEnf,
  );

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 1366); // Initial check

  const [form] = Form.useForm();
  const [formLayout] = useState("horizontal");

  const idUser = JSON.parse(localStorage.getItem("auth")).idUser;
  const idEnf = JSON.parse(localStorage.getItem("auth")).idEnf;

  const nombreUser = JSON.parse(localStorage.getItem("auth")).nombre;

  const fechaLarga = JSON.parse(localStorage.getItem("auth")).confApp.fechas
    .fechaLarga;

  const [fecha] = useState(
    JSON.parse(localStorage.getItem("auth")).confApp.fechas.fechaFmtUsa,
  );
  const [date, setDate] = useState("");

  const [api, contextHolder] = notification.useNotification();
  const initialized = useRef(false);
  const modal = useRef();

  const [idSesion, setIdSesion] = useState(0);
  const [idHojaEnf, setIdHojaEnf] = useState(0);
  const [hora, setHora] = useState("");
  const [dataHorarios, setDataHorarios] = useState([]);
  const [dataVerificaProc, setDataVerificaProc] = useState([]);
  const [idTurno, setIdTurno] = useState("");
  const [idPaciente, setIdPaciente] = useState(0);
  const [paciente, setPaciente] = useState("");
  const [idMaq, setIdMaq] = useState(0);
  const [identifica, setIdentifica] = useState("");
  const [pesoIngreso, setPesoIngreso] = useState(0);
  const [pesoSeco, setPesoSeco] = useState(0);
  const [pesoRemover, setPesoRemover] = useState(0);
  const [serologia, setSerologia] = useState("");
  const [seroPositiva, setSeroPositiva] = useState("");
  const [tensionArt, setTensionArt] = useState("");
  const [frecCard, setFrecCard] = useState(0);
  const [frecResp, setFrecResp] = useState(0);
  const [temp, setTemp] = useState(0);
  const [dataAccesoVasc, setADataccesoVasc] = useState([]);
  const [idAccesoVasc, setIdAccesoVasc] = useState(0);

  const [listInsumos, setListInsumos] = useState([]);
  const [idFiltro, setIdFiltro] = useState("");
  const [idAsigna, setIdAsigna] = useState(0);
  const [tipoDial, setTipoDial] = useState("");
  const [filtro, setFiltro] = useState({});
  const [numReusos, setNumReusos] = useState(0);
  const [tiempoDial, setTiempoDial] = useState("");
  const [entradaDial, setEntradaDial] = useState("");
  const [liquidoDial, setLiquidoDial] = useState(0);
  const [perfilNa, setPerfilNa] = useState("0");
  const [perfilUf, setPerfilUf] = useState("0");
  const [heparinaBolo, setHeparinaBolo] = useState(0);
  const [infusion, setInfusion] = useState(0);
  const [solucionHemo, setSolucionHemo] = useState("");
  const [dataTotalHep] = useState(confApp.VALORES_HEPARINA_BOLO);
  const [dataPErfilUfNa] = useState(confApp.PERFIL_UF_NA);
  const [totalHep, setTotalHep] = useState(0);

  const [zeroSelected, setZeroelected] = useState(false);
  const [oneSelected, setOneSelected] = useState(false);
  const [twoSelected, setTwoSelected] = useState(false);
  const [threeSelected, setThreeSelected] = useState(false);
  const [fourSelected, setFourSelected] = useState(false);
  const [fiveSelected, setFiveSelected] = useState(false);
  const [escalaDolor, setEscalaDolor] = useState(0);
  const [pesoEgreso, setPesoEgreso] = useState(0);
  const [sangreProc, setSangreProc] = useState(0);
  const [ultraFiltra, setUltraFiltra] = useState(0);
  const [horaEgreso, setHoraEgreso] = useState("");
  const [presionArtEgreso, setPresionArtEgreso] = useState(0);
  const [fcEgreso, setFcEgreso] = useState(0);
  const [frEgreso, setFrEgreso] = useState(0);
  const [tempEgreso, setTempEgreso] = useState(0);
  const [gradoRiesgo, setGradoRiesgo] = useState(null);
  const [observa, setObserva] = useState("");

  const [dataPacientes, setDataPacientes] = useState([]);
  const [dataTurnos, setDataTurnos] = useState([]);
  const [dataSegs, setDataSegs] = useState([]);
  const [noSesion, setNoSesion] = useState(0);
  const [edad, setEdad] = useState(0);
  const [sexo, setSexo] = useState("");
  const [dataFirma, setDataFirma] = useState("");
  const [dataFirmaEnf, setDataFirmaEnf] = useState("");
  const [imageFirmaPac, setImageFirmaPac] = useState(null);
  const [imageFirmaEnf, setImageFirmaEnf] = useState(null);
  const [loadFirmaEnf, setLoadFirmaEnf] = useState(null);
  const [loadFirmaPac, setLoadFirmaPac] = useState(null);
  const [listInvent, setListInvent] = useState([]);
  const [idEntrada, setIdEntrada] = useState(0);
  const [filtroAsignado, setFiltroAsignado] = useState(false);

  const [idSeguimiento, setIdSeguimiento] = useState(0);
  const [estatusHojaEnf, setEstatusHojaEnf] = useState("");
  const [camposVerifica, setCamposVerifica] = useState(0);
  const [hojaValida, setHojaValida] = useState(false);
  const [iniciaHoja, setIniciaHoja] = useState(false);
  const [listaCamposPend, setListaCamposPend] = useState([]);

  const signCanvas = useRef({});

  const handleCloseModalSerolog = () => {
    setOpenModalSerolog(false);
    setSeroPositiva("");
    setSerologia("");
  };
  const handleCloseModalSeg = () => {
    setOpenModalSeg(false);
  };
  const handleCloseModalInicia = () => {
    setOpenModalInicia(false);
  };

  const handleCloseModalFirma = () => {
    setOpenModalFirma(false);
  };

  const [idSegHojaEnf, setIdSegHojaEnf] = useState(0);

  const [openModalSeg, setOpenModalSeg] = useState(false);
  const [openModalSerolog, setOpenModalSerolog] = useState(false);
  const [openModalInicia, setOpenModalInicia] = useState(false);
  const [openModalMedics, setOpenModalMedics] = useState(false);
  const [openModalFirma, setOpenModalFirma] = useState(false);
  const [loadingInicio, setLoadingInicio] = useState(false);
  const [horaAplica, setHoraAplica] = useState("");

  // CONSTANTES DE SEGUIMIENTO
  const [horaSeg, setHoraSeg] = useState("");

  const divMobile = {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    maxWidth: "1680px",
    height: "auto",
    padding: "20px",
    margin: "0 auto",
  };

  const controlItem = {
    width: "100%",
    flex: "1",
    minHeight: "45px",
  };

  const errorNotificaction = (title, msj) => {
    api.error({
      title: title,
      description: msj,
      duration: 5,
      styles: { root: { backgroundColor: "#FFE4E0" } },
      showProgress: true,
    });
  };

  const successNotification = (title, msj) => {
    api.success({
      title: title,
      description: msj,
      duration: 5,
      styles: { root: { backgroundColor: "#ECFFE0" } },
      showProgress: true,
    });
  };

  const toast = (msg, type = "info") => {
    toaster.push(
      <Message showIcon type={type} closable>
        <strong>{type}!</strong>
        &nbsp; {msg}
      </Message>,
      { duration: 5000, placement: "topCenter" },
    );
  };

  const loadTurnos = async () => {
    await getTurnos(idNegocio)
      .then((res) => {
        setDataTurnos(res);
      })
      .catch((error) => {
        if (error.status === 401) {
          errorNotificaction(
            "Error de inicio",
            "Debe iniciar sesión, antes de continuar...",
          );
          setTimeout(() => {
            window.location = `/#/App`;
          }, 1200);
        } else {
          errorNotificaction(error.name, error.message);
        }
      });
  };

  const handleEscalasSelected = (props) => {
    if (props.opc === 0) {
      setZeroelected(true);
      setOneSelected(false);
      setTwoSelected(false);
      setThreeSelected(false);
      setFourSelected(false);
      setFiveSelected(false);
    }
    if (props.opc === 1) {
      setZeroelected(false);
      setOneSelected(true);
      setTwoSelected(false);
      setThreeSelected(false);
      setFourSelected(false);
      setFiveSelected(false);
    }
    if (props.opc === 2) {
      setZeroelected(false);
      setOneSelected(false);
      setTwoSelected(true);
      setThreeSelected(false);
      setFourSelected(false);
      setFiveSelected(false);
    }
    if (props.opc === 3) {
      setZeroelected(false);
      setOneSelected(false);
      setTwoSelected(false);
      setThreeSelected(true);
      setFourSelected(false);
      setFiveSelected(false);
    }
    if (props.opc === 4) {
      setZeroelected(false);
      setOneSelected(false);
      setTwoSelected(false);
      setThreeSelected(false);
      setFourSelected(true);
      setFiveSelected(false);
    }
    if (props.opc === 5) {
      setZeroelected(false);
      setOneSelected(false);
      setTwoSelected(false);
      setThreeSelected(false);
      setFourSelected(false);
      setFiveSelected(true);
    }
    setEscalaDolor(props.opc);

    if (props.upd === 1)
      updateCampo("escalaDolor", {
        target: {
          value: props.opc,
        },
      });
  };

  const loadPacientes = async (e) => {
    if (e === null) {
      setDataPacientes([]);
      return;
    }

    setHora(e);
    await getPacientesSesion(idNegocio, idEnf, fecha, e)
      .then((res) => {
        setDataPacientes(res);
      })
      .catch((error) => {
        if (error.status === 401) {
          errorNotificaction(
            "Inicio de sesión",
            "Debe iniciar sesión, antes de continuar...",
          );
          setTimeout(() => {
            window.location = `/#/App`;
          }, 1200);
        } else {
          errorNotificaction(error.name, error.message);
        }
      });
  };

  const loadAccesoVascular = async () => {
    await getAccesoVascular(idNegocio)
      .then((res) => {
        setADataccesoVasc(res);
      })
      .catch((err) => {
        errorNotificaction(err.name, err.message);
      });
  };

  const updateRespuesta = async (e, noPreProc) => {
    const data = {
      id: idNegocio,
      idHojaEnf: idHojaEnf,
      noPreProc: noPreProc,
      respuesta: e === undefined ? "NO" : e,
    };

    await saveVerificaPre(data)
      .then(async (res) => {
        if (res.data > 0) {
          toast("Se ha registrado la respuesta", "success");
          await getVerificaProc(idNegocio, idHojaEnf).then((res) => {
            setDataVerificaProc(res);
          });
        } else {
          toast("Ocurrio un error al registrar", "error");
        }
      })
      .catch((err) => {
        toast(err.message, err.name);
      });
  };

  const fetchHorarios = async (e) => {
    if (e === null) {
      setDataHorarios([]);
      return;
    }

    setIdTurno(e);
    await getHorariosTurno(idNegocio, e)
      .then(async (res) => {
        setDataHorarios(res);
      })
      .catch((error) => {
        if (error.status === 401) {
          errorNotificaction(
            "Inicio de sesión",
            "Debe iniciar sesión, antes de continuar...",
          );
          setTimeout(() => {
            window.location = `/#/App`;
          }, 1200);
        } else {
          errorNotificaction(error.name, error.message);
        }
      });
  };

  const loadFiltroAsignado = async (e) => {
    if (e === null) {
      setIdSesion(0);
      setDataVerificaProc([]);
      setEdad(0);
      setSexo("");
      setIdPaciente(0);
      return;
    }

    const selectedItem = dataPacientes.find((item) => item.value === e);
    setIdPaciente(e);
    setPaciente(selectedItem.label);

    await getFiltroAsignadoSesion(idNegocio, e)
      .then(async (res) => {
        if (!res) {
          setFiltroAsignado(res);
          await getAsignacion(idNegocio, e)
            .then(async (res) => {
              await getFiltrosXInventario(idNegocio).then((res) => {
                setListInvent(res);
                setOpenModalInicia(true);
              });
            })
            .catch((err) => {
              errorNotificaction("Error", err.message);
            });
        } else {
          setFiltroAsignado(res);
          handleOpenModalInicia(e);
        }
      })
      .catch((err) => {
        errorNotificaction(err.name, err.message);
      });
  };

  const maskTime = (value, opc) => {
    if (opc === "entrada") {
      setEntradaDial(
        value
          .replace(/\D/g, "")
          .replace(/(\d{2})(\d)/, "$1:$2")
          .replace(/(\d{2})(\d)/, "$1:$2"),
      );
    }
    if (opc === "tiempoDial") {
      setTiempoDial(
        value
          .replace(/\D/g, "")
          .replace(/(\d{2})(\d)/, "$1:$2")
          .replace(/(\d{2})(\d)/, "$1:$2"),
      );
    }
    if (opc === "horaSeg") {
      setHoraSeg(
        value
          .replace(/\D/g, "")
          .replace(/(\d{2})(\d)/, "$1:$2")
          .replace(/(\d{2})(\d)/, "$1:$2"),
      );
    }
    if (opc === "horaEgreso") {
      setHoraEgreso(
        value
          .replace(/\D/g, "")
          .replace(/(\d{2})(\d)/, "$1:$2")
          .replace(/(\d{2})(\d)/, "$1:$2"),
      );
    }
  };

  const loadVerificaPreProc = async () => {
    await getVerificaProc(idNegocio, idSesion)
      .then((res) => {
        setDataVerificaProc(res);
      })
      .catch((err) => {
        errorNotificaction(err.name, err.message);
      });
  };

  const validacionCierre = async () => {
    let hojaValida = true;
    // dataSegs.length > 2 &&
    //   gradoRiesgo !== null &&
    //   camposVerifica === dataVerificaProc.length

    const _lista = await getValidaCierre(idNegocio, idHojaEnf);
    setListaCamposPend(_lista);
    if (_lista.length > 0) {
      const msj = `Los siguientes campos están pendientes: ${_lista}`;
      errorNotificaction("Datos incompletos", msj);
      hojaValida = false;
    }
    // gradoRiesgo !== null &&
    //   camposVerifica === dataVerificaProc.length

    const _dataSegs = dataSegs.find((itm) => itm.estatus === 'Pendiente');
    
    if (_dataSegs !== undefined) {
      errorNotificaction(
        "Signos",
        "Registra la información de los seguimientos...",
      );
      hojaValida = false;
    }

    if (gradoRiesgo === null) {
      hojaValida = false;
      errorNotificaction(
        "Grado de riesgo",
        "Selecciona una opción del grado de riesgo",
      );
    }

    if (camposVerifica !== dataVerificaProc.length) {
      errorNotificaction(
        "Verificación de procedimiento",
        "Revisa la verificación del procedimiento...",
      );
      hojaValida = false;
    }

    // if (estatusHojaEnf !== "Cerrada") {
    //   errorNotificaction(
    //     "Datos incompletos",
    //     "La hoja de enfermería no se encuentra cerrada, revisa todos los campos.",
    //   );
    //   hojaValida = false;
    // }
    // if (dataSegs.length < 3) {
    //   errorNotificaction(
    //     "Datos incompletos",
    //     "Debe registrar al menos 3 seguimientos para cerrar la hoja de enfermería.",
    //   );
    //   hojaValida = false;
    // }
    // if (gradoRiesgo === null) {
    //   errorNotificaction(
    //     "Datos incompletos",
    //     "Debe seleccionar el grado de riesgo de caída.",
    //   );
    //   hojaValida = false;
    // }
    // if (camposVerifica !== dataVerificaProc.length) {
    //   errorNotificaction(
    //     "Datos incompletos",
    //     "Debe completar todos los campos de verificación.",
    //   );
    //   hojaValida = false;
    // }
    return hojaValida;
  };

  const calculaEdad = (e) => {
    const hoy = new Date(); // Fecha actual
    const fechaNac = new Date(e); // Fecha de nacimiento del input

    let edad = hoy.getFullYear() - fechaNac.getFullYear(); // Diferencia de años inicial

    const mesActual = hoy.getMonth();
    const mesNac = fechaNac.getMonth();

    // Si el mes actual es menor que el mes de nacimiento, no ha cumplido años
    if (mesActual < mesNac) {
      edad--;
    } else if (mesActual === mesNac) {
      // Si los meses son iguales, revisamos el día
      const diaActual = hoy.getDate();
      const diaNac = fechaNac.getDate();
      if (diaActual < diaNac) {
        edad--; // No ha cumplido años aún en el mes actual
      }
    }

    // Para obtener meses y días exactos (más complejo, pero posible)
    // Se puede calcular la diferencia en milisegundos y convertir, o iterar meses/días
    // El método anterior solo da los años cumplidos.
    setEdad(edad);
  };

  const handleSeroPositiva = (e) => {
    setSeroPositiva(e);
    updateCampo("seroPositiva", e);
    setOpenModalSerolog(false);
  };

  const cleanForm = () => {
    form.resetFields();
  };

  const handleChangeSero = (e) => {
    if (e === null) {
      setSerologia("");
      setSeroPositiva("");
      return;
    }

    setSerologia(e);
    updateCampo("serologia", {
      target: {
        value: e,
      },
    });
    if (e === "Positiva") {
      setOpenModalSerolog(true);
    }
  };

  const addSeguimiento = async (values) => {
    const newObj = {
      ...values,
      id: idNegocio,
      idHojaEnf: idHojaEnf,
      idSeg: idSegHojaEnf,
    };

    await saveSeguimiento(newObj)
      .then((res) => {
        if (res.data > 0) {
          loadSeguimientos(idHojaEnf);
          successNotification(
            "Seguimiento",
            "Se han registrado los valores de forma correcta.",
          );
          setOpenModalSeg(false);
        } else {
          errorNotificaction("Error", "Ocurrio un error al guardar...");
        }
      })
      .catch((error) => {
        errorNotificaction(error.name, error.message);
      });
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  const validateMessages = {
    required: "* Obligatorio",
    types: {
      email: "* El campo de correo no es valido",
      number: "* El campo no es un número!",
    },
    number: {
      range: "${label} must be between ${min} and ${max}",
    },
  };

  const updateCampo = async (campo, e) => {
    const data = {
      id: idNegocio,
      ttlCamposValida: camposHojaEnf,
      idSesion: idSesion,
      idHojaEnf: idHojaEnf,
      idPac: idPaciente,
      idMaq: idMaq,
      idFiltro: idFiltro,
      campo: `${campo}=${e.target.value}`,
    };

    await saveCampoHoja(data)
      .then((res) => {
        if (res.data === -1) {
          return;
        }

        setEstatusHojaEnf(res.data);
        toast("El dato se ha actualizado de forma correcta.", "success");
      })
      .catch((err) => {
        toast("El dato no se actualizo, valide la información.", "warning");
      });
  };

  const handleOpenModalInicia = async (e) => {
    const selectedItem = dataPacientes.find((item) => item.value === e);
    setIdPaciente(e);
    setPaciente(selectedItem.label);

    await getAsignacion(idNegocio, e).then(async (res) => {
      if (res !== "") {
        setFiltroAsignado(true);
        setOpenModalInicia(true);
      } else {
        await getAsignacion(idNegocio, e)
          .then(async (res) => {
            await getFiltrosXInventario(idNegocio).then((res) => {
              setIdEntrada(0);
              setListInvent(res);
              setOpenModalInicia(true);
            });
          })
          .catch((err) => {
            errorNotificaction("Error", err.message);
          });
      }
    });
  };

  const loadInicioSesion = async (props) => {
    const data = {
      id: idNegocio,
      idSesion: props.idSesion,
      idPaciente: props.idPac,
      idEnf: idEnf,
      idPac: props.idPac,
      idMaq: props.idMaq,
      idFiltro: props.idFiltro,
      pesoIngreso: props.pesoIngreso,
      noSesionSem: props.noSesion,
    };

    var _idHoja = 0;
    var _idSesion = 0;
    await iniciaHojaEnf(data)
      .then((res) => {
        setIdHojaEnf(res.data.idHoja);
        _idSesion = res.data.idSesion;
        setCamposVerifica(res.data.camposVerifica);
        setEstatusHojaEnf(res.data.estatus);

        successNotification(
          "Inicio de actividad",
          "Se ha registrado la hoja de enfermería.",
        );
      })
      .then(async (res) => {
        await getHojaEnfermeria(idNegocio, _idSesion).then((res) => {
          _idHoja = res.idHoja;
          setIdAccesoVasc(res.idAccesoVasc);
          setPesoSeco(res.pesoSeco);
          setPesoRemover(res.pesoRemover);
          setEntradaDial(res.horaEntrada);
          setIdAccesoVasc(res.idAccesoVasc);
          setPesoRemover(res.pesoRemover);
          var _horaEnt = res.horaEntrada;
          var horaEnt = "";
          if (_horaEnt.length > 0) {
            horaEnt = _horaEnt.substring(0, 5);
          }

          setIdAccesoVasc(res.idAccesoVasc);
          setEntradaDial(horaEnt);
          setSerologia(res.serologia);
          setSeroPositiva(res.seroPositiva);
          setTensionArt(res.presionArt);
          setFrecCard(res.fc);
          setFrecResp(res.fr);

          setTemp(res.temp);

          var _tiempoDial = res.tiempoDial === null ? "00:00" : res.tiempoDial;
          if (_tiempoDial.length > 0) {
            _tiempoDial = res.tiempoDial;
          }
          setTiempoDial(_tiempoDial);

          setLiquidoDial(res.flujoDial);
          setPerfilNa(res.perfilNa === null ? "0" : String(res.perfilNa));
          setPerfilUf(res.perfilUf === null ? "0" : String(res.perfilUf));

          setHeparinaBolo(res.heparinaBolo);
          setInfusion(res.infusion);
          setTotalHep(res.ttlAntiCoag);
          setSangreProc(res.sangreProc);
          setPesoEgreso(res.pesoEgreso);
          setUltraFiltra(res.ultraFiltraTtl);
          var _horaEgreso = res.horaEgreso;
          if (_horaEgreso.length > 0) {
            _horaEgreso = _horaEgreso.substring(0, 5);
          }
          setHoraEgreso(_horaEgreso);
          setPresionArtEgreso(res.presionArtEgreso);
          setFcEgreso(res.fcEgreso);
          setFrEgreso(res.frEgreso);
          setTempEgreso(res.tempEgreso);
          setEscalaDolor(res.escalaDolor);

          handleEscalasSelected({
            opc: res.escalaDolor,
            upd: 0,
          });

          setGradoRiesgo(res.riesgoCaida);
          //setImageFirmaEnf(`Unidades/${idNegocio}/Enfermeria/${idEnf}/${idEnf}firmaEnfermera.png`);
          setLoadFirmaEnf(res.firmaEnf);
          setLoadFirmaPac(res.firmaPac);

          setObserva(res.obs);
          setLoadingInicio(false);
          setOpenModalInicia(false);
        });
      })
      .then(async (res) => {
        await getVerificaProc(idNegocio, _idHoja).then((res) => {
          setDataVerificaProc(res);
        });
      })
      .then(async (res) => {
        loadSeguimientos(_idHoja);
      })
      .catch((err) => {
        setLoadingInicio(false);
        errorNotificaction(err.name, err.message);
      });
  };

  const handleChecked = (e, opc) => {
    var valorChecked = e;
    if (!e) {
      opc = null;
    }
    updateCampo("riesgoCaida", {
      target: {
        value: opc,
      },
    }).then((res) => {
      setGradoRiesgo(opc);
    });
  };

  const clear = () => signCanvas.current.clear();

  const saveSignature = () => {
    if (signCanvas.current) {
      const data = signCanvas.current.toDataURL("image/png");
      setImageFirmaEnf(data);
      setDataFirmaEnf(data);
      setOpenModalFirma(false);
    }
  };

  const saveSignaturePac = () => {
    if (signCanvas.current) {
      const data = signCanvas.current.toDataURL("image/png");
      setImageFirmaPac(data);
      saveFirma(data);
    }
  };

  const handleSaveAsigna = async () => {
    const data = {
      id: idNegocio,
      idPac: idPaciente,
      idEntrada: idEntrada,
      idUser: idUser,
      claveSerie: "",
    };

    await saveAsignaFiltro(data).then(async (res) => {
      return res.data;
    });
  };

  const handleDatosPaciente = async () => {
    var _idFiltro = "";
    var _idAsigna = 0;
    var _idSesion = 0;
    var _idPaciente = 0;
    var _pesoIngreso = 0;
    var _idMaq = 0;
    var _noSesiones = 0;

    setLoadingInicio(true);

    const asignacion = !filtroAsignado ? await handleSaveAsigna() : 1;

    if (asignacion === 0) {
      errorNotificaction("Error", "No se asigno el filtro...");
      return;
    }

    await getDatospaciente(idNegocio, idPaciente, fecha, hora)
      .then((response) => {
        setIdSesion(response.idSesion);
        _idSesion = response.idSesion;
        _idPaciente = response.idPaciente;
        _pesoIngreso = response.pesoInicial;
        _idMaq = response.idMaquina;

        let _fecha = response.fechaNac;
        if (_fecha !== null) {
          var _fecNac = new Date(response.fechaNac);
          _fecNac.setDate(_fecNac.getDate() + 1);
          calculaEdad(_fecNac);
        } else {
          setEdad(0);
        }

        setSexo(response.genero);
        setPesoIngreso(response.pesoInicial);
        setIdMaq(response.idMaquina);
        setIdentifica(response.identifica);
        setIdFiltro(response.idFiltro);
        _idFiltro = response.idFiltro;
        setIdAsigna(response.idAsigna);
        _idAsigna = response.idAsigna;
      })
      .then(async (res) => {
        await getInsumosSesion(idNegocio, _idSesion)
          .then(async (res) => {
            setListInsumos(res);
          })
          .then(async (res) => {
            await getAccesoVascular(idNegocio)
              .then(async (res) => {
                setADataccesoVasc(res);
              })
              .then(async (res) => {
                await getDataFiltro(idNegocio, _idFiltro)
                  .then(async (res) => {
                    setTipoDial(res.tipo);
                    setFiltro(res);
                  })
                  .then(async (res) => {
                    await getNumSesionesSem(idNegocio, idPaciente, _idAsigna)
                      .then((res) => {
                        setNoSesion(res.conteo);
                        setNumReusos(res.reusos);
                        _noSesiones = res.conteo;
                      })
                      .then(async (res) => {
                        loadInicioSesion({
                          idSesion: _idSesion,
                          idPac: _idPaciente,
                          idFiltro: _idFiltro,
                          idMaq: _idMaq,
                          pesoIngreso: _pesoIngreso,
                          noSesion: _noSesiones,
                        });
                      });
                  });
              });
          });
      })
      .catch((error) => {
        errorNotificaction(error.name, error.message);
      });
  };

  const handleOpenModalFirma = async (firma) => {
    if (estatusHojaEnf === "Finalizada") {
      return;
    }

    const cierreValido = await validacionCierre();

    if (cierreValido) {
      if (firma === "Paciente" && imageFirmaEnf === null) {
        errorNotificaction(
          "Firma enfermero(a)",
          "Ingresa tú firma antes de continuar.",
        );
        return;
      }
      if (firma === "Paciente" && imageFirmaEnf !== null) {
        setOpenModalFirma(true);
      }
      if (firma !== "Paciente") {
        setImageFirmaEnf(
          `Unidades/${idNegocio}/Enfermeria/${idEnf}/${idEnf}firmaEnfermera.png`,
        );
      }
      setDataFirma(`${firma}`);
      // setOpenModalFirma(true);
    }
  };

  const updateHora = async (props) => {
    if (props.hora === "HH:mm") {
      return;
    }

    const data = {
      id: idNegocio,
      idSesion: idSesion,
      noItem: props.noItem,
      idInsumo: props.idInsumo,
      hora: props.hora,
    };

    await saveHoraAplica(data)
      .then(async (res) => {
        if (res.data > 0) {
          toast("Se actualizó la hora de aplicación del insumo", "success");
          await getInsumosSesion(idNegocio, idSesion)
            .then((res) => {
              setListInsumos(res);
            })
            .catch((err) => {
              errorNotificaction(err.name, err.message);
            });
        }
      })
      .catch((err) => {
        errorNotificaction(err.name, err.message);
      });
  };

  // const getDataOfCell = (e, rowIndex, colName, noItem, idInsumo) => {
  //   const newValue = e.target.innerText; // or innerHTML
  //   const updatedData = [...listInsumos];
  //   updatedData[rowIndex][colName] = newValue;

  //   console.log(data);
  // };

  const getDataOfCellChange = (e, rowIndex) => {
    const newValue = e.target.innerText;
    newValue.Body.replace(/\D/g, "")
      .replace(/(\d{2})(\d)/, "$1:$2")
      .replace(/(\d{2})(\d)/, "$1:$2");

    const updatedData = [...listInsumos];
    updatedData[rowIndex]["hora"] = newValue;
  };

  const handleTotalHep = (e) => {
    if (e === null) {
      setTotalHep(0);
      e = 0;
    }

    setTotalHep(e);
    const obj = {
      target: {
        value: e,
      },
    };
    updateCampo("totalHep", obj);
  };

  const loadSeguimientos = async (idHoja) => {
    await getSeguimientos(idNegocio, idHoja).then((res) => {
      setDataSegs(res);
    });
  };

  const handleHeparinaBolo = (e) => {
    if (e === null) {
      setHeparinaBolo(0);
      e = 0;
    }
    setHeparinaBolo(e);

    const obj = {
      target: {
        value: e,
      },
    };

    updateCampo("heparinaBolo", obj);
  };

  const handleUpdatePerfilUF = (e) => {
    if (e === null) {
      setPerfilUf(0);
      e = 0;
    }
    setPerfilUf(e);

    const obj = {
      target: {
        value: e,
      },
    };

    updateCampo("perfilUf", obj);
  };

  const handleUpdatePerfilNa = (e) => {
    if (e === null) {
      setPerfilNa(0);
      e = 0;
    }
    setPerfilNa(e);

    const obj = {
      target: {
        value: e,
      },
    };

    updateCampo("perfilNa", obj);
  };

  const handleInfusion = (e) => {
    if (e === null) {
      setInfusion(0);
    }
    setInfusion(e);
    const obj = {
      target: {
        value: e,
      },
    };
    updateCampo("infusion", obj);
  };

  const saveFirma = async (firmaPac) => {
    const data = {
      id: idNegocio,
      idSesion: idSesion,
      idHoja: idHojaEnf,
      firmaEnf: dataFirmaEnf,
      firmaPac: firmaPac,
    };

    await saveFirmaHojaEnf(data)
      .then((res) => {
        setEstatusHojaEnf(res.data);
        setOpenModalFirma(false);
      })
      .catch((err) => {
        errorNotificaction(err.name, err.message);
      });
  };

  const handleAccesoVasc = (e) => {
    setIdAccesoVasc(e);
    if (e !== null) {
      const obj = {
        target: {
          value: e,
        },
      };
      updateCampo("idAccesoVasc", obj);
    }
  };

  const handleObserva = (e) => {
    setObserva(e.target.value);
  };

  const loadInsumos = async () => {
    await getInsumosSesion(idNegocio, idSesion)
      .then(async (res) => {
        setListInsumos(res);
      })
      .catch((err) => {
        errorNotificaction(err.name, err.message);
      });
  };

  const handleModalOpenSeg = async (showData, hora) => {
    await getHoraActual().then(async (res) => {
      if (showData) {
        await getSeguimientosHoja(idNegocio, idHojaEnf, hora).then((res) => {
          setIdSegHojaEnf(res.idSeg);
          setHoraSeg(res.hora);
          form.setFieldsValue({
            temp: res.temp,
            fc: res.fc,
            fr: res.fr,
            ta: res.ta === "0" ? "" : res.ta,
            fd: res.fd,
            fs: res.fs,
            pv: res.pv,
            tmp: res.tmp,
            na: res.na,
            uf: res.uf,
          });
        });
      } else {
        setIdSegHojaEnf(0);
        setHoraSeg(res);
        cleanForm();
      }
      setOpenModalSeg(true);
    });
  };

  const handleFocus = (event) => event.target.select();

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 1366); // Update on resize
    };

    window.addEventListener("resize", handleResize);
    // Set up an interval to update the time every second

    if (!initialized.current) {
      initialized.current = true;
      loadTurnos();
    }
  }, []);

  return (
    <>
      <title>Hoja de Enfermería</title>
      <LayoutHome
        titleItems={[
          {
            title: (
              <a href="/#/App/Home" style={{ textDecoration: "none" }}>
                Menú
              </a>
            ),
          },
          { title: "Hoja de Enfermería" },
        ]}
        selectedKey={"HojaEnfermeria"}
      >
        {contextHolder}
        <div style={isMobile ? divMobile : {}}>
          <Panel bordered>
            <div className="row">
              <div className="text-end col-lg-8-col-md-8 col-sm-8">
                <Text size={"xl"} weight="bold">
                  HOJA DE ENFERMERÍA PARA HEMODIÁLISIS
                </Text>
              </div>
              <div className="col-lg-1 col-md-1 col-sm-1">&nbsp;</div>
              <div className="text-center col-lg-3 col-md-3 col-sm-3">
                <Box
                  mb={2}
                  bd="1px solid var(--rs-border-primary)"
                  rounded="lg"
                  style={{ padding: "5px" }}
                >
                  <Text size={"lg"} weight="semibold">
                    Folio No. {idHojaEnf}
                  </Text>
                </Box>
              </div>
            </div>
          </Panel>
          <Panel>
            <div className="row mb-2">
              <div
                className="col-lg-2 col-md-2 col-sm-2"
                style={{
                  display: "flex",
                  flexDirection: "column",
                  minWidth: "230px",
                }}
              >
                <Text size={"md"}>Fecha</Text>
                <Input
                  readOnly
                  style={{ fontSize: "14px" }}
                  value={fechaLarga}
                  variant="underlined"
                />
              </div>
              <div
                className="col-lg-2 col-md-2 col-sm-2"
                style={{
                  display: "flex",
                  flexDirection: "column",
                  minWidth: "140px",
                }}
              >
                <Text size={"md"}>Turno</Text>
                <SelectPicker
                  placeholder="-"
                  searchable={false}
                  data={dataTurnos}
                  onChange={(e) => fetchHorarios(e)}
                  block
                />
              </div>
              <div
                className="col-lg-1 col-md-1 col-sm-1"
                style={{
                  display: "flex",
                  flexDirection: "column",
                  minWidth: "140px",
                }}
              >
                <Text size={"md"}>Horario</Text>
                <SelectPicker
                  block
                  searchable={false}
                  value={hora}
                  data={dataHorarios}
                  placeholder="-"
                  onChange={(e) => loadPacientes(e)}
                />
              </div>
              <div
                className="col-lg-4 col-md-4 col-sm-4"
                style={{
                  display: "flex",
                  flexDirection: "column",
                  minWidth: "100px",
                }}
              >
                <Text size={"md"}>Paciente</Text>
                <SelectPicker
                  block
                  value={idPaciente}
                  data={dataPacientes}
                  onChange={(e) => loadFiltroAsignado(e)}
                  placeholder="-"
                />
              </div>
              <div
                className="text-center col-lg-1 col-md-1 col-sm-1"
                style={{
                  display: "flex",
                  flexDirection: "column",
                  minWidth: "50px",
                }}
              >
                <Text size={"md"}>Edad</Text>
                <Input
                  readOnly
                  variant="underlined"
                  style={{ textAlign: "center", fontWeight: "bold" }}
                  value={edad}
                />
              </div>
              <div
                className="text-center col-lg-1 col-md-1 col-sm-1"
                style={{
                  display: "flex",
                  flexDirection: "column",
                  minWidth: "50px",
                }}
              >
                <Text size={"md"}>Sexo</Text>
                <Input
                  variant="underlined"
                  readOnly
                  style={{ textAlign: "center", fontWeight: "bold" }}
                  value={sexo}
                />
              </div>
            </div>
          </Panel>
          <div className="row mb-1"></div>
          <Splitter style={{ overflowX: "hidden" }}>
            <Splitter.Panel
              style={{ padding: "2px", overflowX: "hidden" }}
              defaultSize="75%"
              min="40%"
              max="80%"
            >
              <div className="row mb-1">
                <div className="text-center col">
                  <Text size={"xl"} weight="bold">
                    PREDIÁLISIS
                  </Text>
                </div>
              </div>
              <div className="row">
                <div className="col">
                  <Table
                    key={`tblPreDial`}
                    bordered
                    responsive
                    size="md"
                    style={{ width: "99%" }}
                  >
                    <thead>
                      <tr>
                        <th>
                          <Text>Peso de ingreso:</Text>
                        </th>
                        <th style={{ textAlign: "center" }}>
                          <Input
                            size="small"
                            placeholder="0 Kg"
                            style={{
                              textAlign: "center",
                              backgroundColor: "#E7FBFE",
                            }}
                            value={pesoIngreso}
                            disabled={idSesion > 0 ? false : true}
                            onFocus={handleFocus}
                            onBlur={(e) => updateCampo("pesoIngreso", e)}
                            onChange={(e) => setPesoIngreso(soloNumeros(e))}
                          />
                        </th>
                        <th>
                          <Text>Peso Seco:</Text>
                        </th>
                        <th style={{ textAlign: "center" }}>
                          <Input
                            size="small"
                            placeholder="0 Kg"
                            disabled={idSesion > 0 ? false : true}
                            style={{
                              textAlign: "center",
                              backgroundColor: "#E7FBFE",
                            }}
                            value={pesoSeco}
                            onFocus={handleFocus}
                            onBlur={(e) => updateCampo("pesoSeco", e)}
                            onChange={(e) => setPesoSeco(soloNumeros(e))}
                          />
                        </th>
                        <th colSpan={2}>
                          <Text>Peso a remover:</Text>
                        </th>
                        <th style={{ textAlign: "center" }}>
                          <Input
                            size="small"
                            placeholder="0 Kg"
                            style={{
                              textAlign: "center",
                              backgroundColor: "#E7FBFE",
                            }}
                            value={pesoRemover}
                            disabled={idSesion > 0 ? false : true}
                            onFocus={handleFocus}
                            onBlur={(e) => updateCampo("pesoRemover", e)}
                            onChange={(e) => setPesoRemover(soloNumeros(e))}
                          />
                        </th>
                        <th colSpan={2} style={{ textAlign: "center" }}>
                          <Text>Hora de entrada</Text>
                        </th>
                        <th style={{ textAlign: "center" }} colSpan={4}>
                          <Input
                            placeholder="00:00"
                            maxLength={5}
                            disabled={idSesion > 0 ? false : true}
                            value={entradaDial}
                            onBlur={(e) => updateCampo("entradaDial", e)}
                            onChange={(e) =>
                              maskTime(e.target.value, "entrada")
                            }
                            style={{
                              textAlign: "center",
                              backgroundColor: "#E7FBFE",
                            }}
                          />
                        </th>
                      </tr>
                      <tr>
                        <th>
                          <Text>Acceso vascular:</Text>
                        </th>
                        <th style={{ textAlign: "center", minWidth: "120px" }}>
                          <SelectPicker
                            size="sm"
                            searchable={false}
                            placeholder="-"
                            disabled={idSesion > 0 ? false : true}
                            data={dataAccesoVasc}
                            value={idAccesoVasc}
                            onChange={(e) => handleAccesoVasc(e)}
                            block
                          />
                        </th>
                        <th>
                          <Whisper
                            placement="top"
                            trigger="click"
                            speaker={
                              <Popover
                                title={
                                  seroPositiva !== ""
                                    ? "Serología Positiva"
                                    : ""
                                }
                              >
                                <Text size={"md"}>{seroPositiva}</Text>
                              </Popover>
                            }
                          >
                            <Text>Serología</Text>
                          </Whisper>
                        </th>
                        <th style={{ textAlign: "center", minWidth: "120px" }}>
                          <SelectPicker
                            searchable={false}
                            placeholder="-"
                            size="sm"
                            disabled={idSesion > 0 ? false : true}
                            value={serologia}
                            onChange={(e) => handleChangeSero(e)}
                            block
                            data={[
                              { label: "Negativa", value: "Negativa" },
                              { label: "Positiva", value: "Positiva" },
                              {
                                label: "Indeterminada",
                                value: "Indeterminada",
                              },
                            ]}
                          />
                        </th>
                        <th>
                          <Text>Signos vitales</Text>
                        </th>
                        <th>TA:</th>
                        <th>
                          <Input
                            size="small"
                            disabled={idSesion > 0 ? false : true}
                            placeholder="TA"
                            style={{
                              textAlign: "center",
                              backgroundColor: "#E7FBFE",
                              minWidth: "80px",
                            }}
                            value={tensionArt}
                            onFocus={handleFocus}
                            onEnter={handleFocus}
                            onBlur={(e) => updateCampo("tensionArt", e)}
                            onChange={(e) => setTensionArt(e.target.value)}
                          />
                        </th>
                        <th>FC:</th>
                        <th>
                          <Input
                            size="small"
                            disabled={idSesion > 0 ? false : true}
                            placeholder="FC"
                            style={{
                              textAlign: "center",
                              backgroundColor: "#E7FBFE",
                              minWidth: "60px",
                            }}
                            value={frecCard}
                            onFocus={handleFocus}
                            onEnter={handleFocus}
                            onBlur={(e) => updateCampo("frecCard", e)}
                            onChange={(e) => setFrecCard(soloNumeros(e))}
                          />
                        </th>
                        <th>FR:</th>
                        <th>
                          <Input
                            size="small"
                            disabled={idSesion > 0 ? false : true}
                            placeholder="FR"
                            style={{
                              textAlign: "center",
                              backgroundColor: "#E7FBFE",
                              minWidth: "60px",
                            }}
                            value={frecResp}
                            onFocus={handleFocus}
                            onBlur={(e) => updateCampo("frecResp", e)}
                            onChange={(e) => setFrecResp(soloNumeros(e))}
                          />
                        </th>
                        <th>T:</th>
                        <th>
                          <Input
                            size="small"
                            disabled={idSesion > 0 ? false : true}
                            placeholder="T"
                            style={{
                              textAlign: "center",
                              backgroundColor: "#E7FBFE",
                              minWidth: "60px",
                            }}
                            value={temp}
                            onFocus={handleFocus}
                            onBlur={(e) => updateCampo("temp", e)}
                            onChange={(e) => setTemp(soloNumeros(e))}
                          />
                        </th>
                      </tr>
                    </thead>
                  </Table>
                </div>
              </div>
              <div className="row">
                <div className="text-center col">
                  <Text size={"xl"} weight="bold">
                    DIÁLISIS
                  </Text>
                  <Table
                    key={`tblDial`}
                    bordered
                    responsive
                    size="md"
                    style={{ width: "99%" }}
                  >
                    <thead>
                      <tr>
                        <th>No. de Sesión</th>
                        <th style={{ textAlign: "center" }}>{noSesion}</th>
                        <th>Maquina Núm: </th>
                        <th style={{ textAlign: "center" }}>{identifica}</th>
                        <th>Dializador tipo:</th>
                        <th style={{ textAlign: "center" }}>{tipoDial}</th>
                        <th>Superficie:</th>
                        <th style={{ textAlign: "center" }}>
                          {filtro.clasifica}
                        </th>
                      </tr>
                      <tr>
                        <th>Núm de Rehuso:</th>
                        <th style={{ textAlign: "center" }}>{numReusos}</th>
                        <th>Tiempo de diálisis</th>
                        <th style={{ textAlign: "center" }}>
                          <Input
                            placeholder="HH:mm"
                            maxLength={5}
                            size="small"
                            disabled={idSesion > 0 ? false : true}
                            value={tiempoDial}
                            onBlur={(e) => updateCampo("tiempoDial", e)}
                            onChange={(e) =>
                              maskTime(e.target.value, "tiempoDial")
                            }
                            style={{
                              textAlign: "center",
                              backgroundColor: "#E7FBFE",
                            }}
                          />
                        </th>
                        <th>Liquido dializante:</th>
                        <th style={{ textAlign: "center" }}>
                          <Input
                            value={liquidoDial}
                            size="small"
                            disabled={idSesion > 0 ? false : true}
                            style={{
                              textAlign: "center",
                              backgroundColor: "#E7FBFE",
                            }}
                            onFocus={handleFocus}
                            onBlur={(e) => updateCampo("liquidoDial", e)}
                            onChange={(e) => setLiquidoDial(soloNumeros(e))}
                          />
                        </th>
                        <th>Perfil de Na</th>
                        <th>
                          <SelectPicker
                            style={{ minWidth: "60px" }}
                            value={perfilNa}
                            disabled={idSesion > 0 ? false : true}
                            size="sm"
                            data={dataPErfilUfNa}
                            placeholder=""
                            block
                            onChange={(e) => handleUpdatePerfilNa(e)}
                          />
                        </th>
                      </tr>
                      <tr>
                        <th>Perfil de Uf:</th>
                        <th>
                          <SelectPicker
                            style={{ minWidth: "80px" }}
                            value={perfilUf}
                            disabled={idSesion > 0 ? false : true}
                            size="sm"
                            placeholder=""
                            block
                            data={dataPErfilUfNa}
                            onChange={(e) => handleUpdatePerfilUF(e)}
                          />
                        </th>
                        <th>Heparina Bolo:</th>
                        <th>
                          <SelectPicker
                            searchable={false}
                            disabled={idSesion > 0 ? false : true}
                            block
                            data={dataTotalHep}
                            size="sm"
                            placeholder="-"
                            value={heparinaBolo}
                            onChange={(e) => handleHeparinaBolo(e)}
                          />
                        </th>
                        <th>Infusión:</th>
                        <th>
                          <SelectPicker
                            searchable={false}
                            disabled={idSesion > 0 ? false : true}
                            block
                            data={dataTotalHep}
                            size="sm"
                            placeholder="-"
                            value={infusion}
                            onChange={(e) => handleInfusion(e)}
                          />
                        </th>
                        <th>Total:</th>
                        <th>
                          <SelectPicker
                            searchable={false}
                            disabled={idSesion > 0 ? false : true}
                            block
                            data={dataTotalHep}
                            size="sm"
                            placeholder="-"
                            value={totalHep}
                            onChange={(e) => handleTotalHep(e)}
                          />
                        </th>
                      </tr>
                      <tr>
                        <th colSpan={2} style={{ textAlign: "left" }}>
                          Soluciones y/o hemoderivados:
                        </th>
                        <th colSpan={5}>
                          <Input
                            value={solucionHemo}
                            disabled={idSesion > 0 ? false : true}
                            size="small"
                            style={{ backgroundColor: "#E7FBFE" }}
                            onBlur={(e) =>
                              updateCampo("solucionHemo", {
                                target: {
                                  value: e.target.value,
                                },
                              })
                            }
                            onChange={(e) => setSolucionHemo(e.target.value)}
                          />
                        </th>
                        <th>
                          <Button
                            block
                            variant="outlined"
                            color="primary"
                            onClick={() => handleModalOpenSeg(false, "")}
                            disabled={
                              idSesion > 0
                                ? estatusHojaEnf === "Finalizada"
                                  ? true
                                  : false
                                : true
                            }
                            icon={<LucideAArrowDown></LucideAArrowDown>}
                          >
                            Control de signos
                          </Button>
                        </th>
                      </tr>
                    </thead>
                  </Table>
                </div>
              </div>
              <div className="row">
                <div className="col-lg-8 col-md-8 col-sm-8">
                  <Table
                    key={`tblSeguimiento`}
                    bordered
                    responsive
                    size="md"
                    style={{ fontSize: "12px" }}
                  >
                    <thead>
                      <tr>
                        <th style={{ textAlign: "center" }}>HORA</th>
                        <th style={{ textAlign: "center" }}>TEMP.</th>
                        <th style={{ textAlign: "center" }}>F.C.</th>
                        <th style={{ textAlign: "center" }}>F.R.</th>
                        <th style={{ textAlign: "center" }}>TA</th>
                        <th style={{ textAlign: "center" }}>FD</th>
                        <th style={{ textAlign: "center" }}>FS</th>
                        <th style={{ textAlign: "center" }}>PV</th>
                        <th style={{ textAlign: "center" }}>TMP</th>
                        <th style={{ textAlign: "center" }}>NA</th>
                        <th style={{ textAlign: "center" }}>UF</th>
                      </tr>
                    </thead>
                    {dataSegs.length > 0
                      ? dataSegs.map((item, index) => {
                          return (
                            <tbody>
                              <tr key={index}>
                                <td style={{ textAlign: "center" }}>
                                  <Button
                                    color="default"
                                    variant="link"
                                    disabled={estatusHojaEnf === 'Finalizada' ? true : false }
                                    size="small"
                                    style={{ height: "10px", color: "blue" }}
                                    onClick={() =>
                                      handleModalOpenSeg(
                                        true,
                                        item.hora.substring(0, 5),
                                      )
                                    }
                                  >
                                    {item.hora.substring(0, 5)}
                                  </Button>
                                </td>
                                <td
                                  style={{
                                    textAlign: "center",
                                    backgroundColor:
                                      item.estatus === "Pendiente"
                                        ? "yellow"
                                        : "",
                                  }}
                                >
                                  {item.temp}
                                </td>
                                <td
                                  style={{
                                    textAlign: "center",
                                    backgroundColor:
                                      item.estatus === "Pendiente"
                                        ? "yellow"
                                        : "",
                                  }}
                                >
                                  {item.fc}
                                </td>
                                <td
                                  style={{
                                    textAlign: "center",
                                    backgroundColor:
                                      item.estatus === "Pendiente"
                                        ? "yellow"
                                        : "",
                                  }}
                                >
                                  {item.fr}
                                </td>
                                <td
                                  style={{
                                    textAlign: "center",
                                    backgroundColor:
                                      item.estatus === "Pendiente"
                                        ? "yellow"
                                        : "",
                                  }}
                                >
                                  {item.ta}
                                </td>
                                <td
                                  style={{
                                    textAlign: "center",
                                    backgroundColor:
                                      item.estatus === "Pendiente"
                                        ? "yellow"
                                        : "",
                                  }}
                                >
                                  {item.fd}
                                </td>
                                <td
                                  style={{
                                    textAlign: "center",
                                    backgroundColor:
                                      item.estatus === "Pendiente"
                                        ? "yellow"
                                        : "",
                                  }}
                                >
                                  {item.fs}
                                </td>
                                <td
                                  style={{
                                    textAlign: "center",
                                    backgroundColor:
                                      item.estatus === "Pendiente"
                                        ? "yellow"
                                        : "",
                                  }}
                                >
                                  {item.pv}
                                </td>
                                <td
                                  style={{
                                    textAlign: "center",
                                    backgroundColor:
                                      item.estatus === "Pendiente"
                                        ? "yellow"
                                        : "",
                                  }}
                                >
                                  {item.tmp}
                                </td>
                                <td
                                  style={{
                                    textAlign: "center",
                                    backgroundColor:
                                      item.estatus === "Pendiente"
                                        ? "yellow"
                                        : "",
                                  }}
                                >
                                  {item.na}
                                </td>
                                <td
                                  style={{
                                    textAlign: "center",
                                    backgroundColor:
                                      item.estatus === "Pendiente"
                                        ? "yellow"
                                        : "",
                                  }}
                                >
                                  {item.uf}
                                </td>
                              </tr>
                            </tbody>
                          );
                        })
                      : ""}
                  </Table>
                </div>
                <div className="col-lg-4 col-md-4 col-sm-4">
                  <Table
                    key={`tblMedics`}
                    bordered
                    responsive
                    size="md"
                    style={{ width: "99%", fontSize: "14px" }}
                  >
                    <thead>
                      <tr>
                        <th style={{ width: "100px" }}>
                          <Button
                            disabled={
                              idSesion > 0
                                ? estatusHojaEnf === "Finalizada"
                                  ? true
                                  : false
                                : true
                            }
                            size="small"
                            color="primary"
                            variant="text"
                            onClick={() => modal.current.open()}
                          >
                            Insumos
                          </Button>
                          &nbsp; &nbsp;
                          <Button
                            onClick={loadInsumos}
                            icon={
                              <RefreshCcw
                                size={isMobile ? 16 : 22}
                              ></RefreshCcw>
                            }
                            disabled={
                              idSesion > 0
                                ? estatusHojaEnf === "Finalizada"
                                  ? true
                                  : false
                                : true
                            }
                            size="small"
                            color="primary"
                            variant="text"
                          />
                        </th>
                        <th style={{ textAlign: "center", width: "50px" }}>
                          Hora aplicación
                        </th>
                      </tr>
                    </thead>
                    {listInsumos.length > 0 ? (
                      <tbody>
                        {listInsumos.map((item, index) => {
                          return (
                            <tr key={`row-${index}`}>
                              <td style={{ fontSize: "12px" }}>
                                {item.insumo}
                              </td>
                              <td>
                                <TimePicker
                                  key={`hora-${index}`}
                                  format="HH:mm"
                                  size="sm"
                                  value={
                                    item.hora !== null
                                      ? new Date(`2026-01-01 ${item.hora}`)
                                      : null
                                  }
                                  onChange={(e) =>
                                    updateHora({
                                      hora: e,
                                      noItem: item.noItem,
                                      idInsumo: item.idInsumo,
                                    })
                                  }
                                />
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    ) : (
                      ""
                    )}
                  </Table>
                </div>
              </div>
              <div className="row">
                <center>
                  <Text size={"xl"} weight="bold">
                    POST DIÁLISIS
                  </Text>
                </center>
                <div className="text-center col-lg-8 col-md-8 col-sm-8">
                  <Table
                    key={`tblPostDial`}
                    bordered
                    responsive
                    size="md"
                    style={{ width: "99%", fontSize: "14px" }}
                  >
                    <thead>
                      <tr>
                        <th colSpan={2}>Sangre procesada:</th>
                        <th colSpan={2} style={{ textAlign: "center" }}>
                          <Input
                            size="small"
                            style={{
                              textAlign: "center",
                              backgroundColor: "#E7FBFE",
                              minWidth: "60px",
                            }}
                            disabled={idSesion > 0 ? false : true}
                            value={sangreProc}
                            onFocus={handleFocus}
                            onBlur={(e) => updateCampo("sangreProc", e)}
                            onChange={(e) => setSangreProc(soloNumeros(e))}
                          />
                        </th>
                        <th colSpan={2}>Peso egreso:</th>
                        <th colSpan={2}>
                          <Input
                            size="small"
                            disabled={idSesion > 0 ? false : true}
                            style={{
                              textAlign: "center",
                              backgroundColor: "#E7FBFE",
                              minWidth: "60px",
                            }}
                            value={pesoEgreso}
                            onFocus={handleFocus}
                            onBlur={(e) => updateCampo("pesoEgreso", e)}
                            onChange={(e) => setPesoEgreso(soloNumeros(e))}
                          />
                        </th>
                        <th colSpan={2}>UFT:</th>
                        <th colSpan={2}>
                          <Input
                            size="small"
                            disabled={idSesion > 0 ? false : true}
                            style={{
                              textAlign: "center",
                              backgroundColor: "#E7FBFE",
                              minWidth: "60px",
                            }}
                            value={ultraFiltra}
                            onFocus={handleFocus}
                            onBlur={(e) => updateCampo("ultraFiltra", e)}
                            onChange={(e) => setUltraFiltra(soloNumeros(e))}
                          />
                        </th>
                      </tr>
                      <tr>
                        <th>Hora egreso</th>
                        <th style={{ textAlign: "center" }}>
                          <Input
                            placeholder="00:00"
                            maxLength={5}
                            disabled={idSesion > 0 ? false : true}
                            value={horaEgreso}
                            onBlur={(e) => updateCampo("horaEgreso", e)}
                            onChange={(e) =>
                              maskTime(e.target.value, "horaEgreso")
                            }
                            style={{
                              textAlign: "center",
                              backgroundColor: "#E7FBFE",
                              minWidth: "100px",
                            }}
                          />
                        </th>
                        <th>Signos Vitales:</th>
                        <th>TA:</th>
                        <th>
                          <Input
                            size="small"
                            disabled={idSesion > 0 ? false : true}
                            style={{
                              textAlign: "center",
                              backgroundColor: "#E7FBFE",
                              minWidth: "80px",
                            }}
                            value={presionArtEgreso}
                            onFocus={handleFocus}
                            onBlur={(e) => updateCampo("presionArtEgreso", e)}
                            onChange={(e) =>
                              setPresionArtEgreso(e.target.value)
                            }
                          />
                        </th>
                        <th>FC:</th>
                        <th>
                          <Input
                            size="small"
                            disabled={idSesion > 0 ? false : true}
                            style={{
                              textAlign: "center",
                              backgroundColor: "#E7FBFE",
                              minWidth: "60px",
                            }}
                            value={fcEgreso}
                            onFocus={handleFocus}
                            onBlur={(e) => updateCampo("fcEgreso", e)}
                            onChange={(e) => setFcEgreso(soloNumeros(e))}
                          />
                        </th>
                        <th>FR:</th>
                        <th>
                          <Input
                            size="small"
                            disabled={idSesion > 0 ? false : true}
                            style={{
                              textAlign: "center",
                              backgroundColor: "#E7FBFE",
                              minWidth: "60px",
                            }}
                            value={frEgreso}
                            onFocus={handleFocus}
                            onBlur={(e) => updateCampo("frEgreso", e)}
                            onChange={(e) => setFrEgreso(soloNumeros(e))}
                          />
                        </th>
                        <th>T:</th>
                        <th>
                          <Input
                            size="small"
                            disabled={idSesion > 0 ? false : true}
                            style={{
                              textAlign: "center",
                              backgroundColor: "#E7FBFE",
                              minWidth: "60px",
                            }}
                            value={tempEgreso}
                            onFocus={handleFocus}
                            onBlur={(e) => updateCampo("tempEgreso", e)}
                            onChange={(e) => setTempEgreso(soloNumeros(e))}
                          />
                        </th>
                      </tr>
                    </thead>
                  </Table>
                </div>
                <div className="col-lg-4 col-md-4 col-sm-4">
                  <Table
                    key={`tblPostDial`}
                    bordered
                    responsive
                    size="md"
                    style={{ width: "99%", fontSize: "14px" }}
                  >
                    <thead>
                      <tr>
                        <th
                          rowSpan={3}
                          style={{ width: "10%", alignContent: "top" }}
                        >
                          Escala del dolor:
                        </th>
                      </tr>
                      <tr>
                        <th style={{ textAlign: "center" }}>
                          <Image
                            src={
                              !zeroSelected
                                ? "/Images/faces/excellent.jpg"
                                : "/Images/faces/excellentSel.jpg"
                            }
                            style={{ height: 30 }}
                          />
                        </th>
                        <th style={{ textAlign: "center" }}>
                          <Image
                            src={
                              !oneSelected
                                ? "/Images/faces/good.jpg"
                                : "/Images/faces/goodSel.jpg"
                            }
                            style={{ height: 30 }}
                          />
                        </th>
                        <th style={{ textAlign: "center" }}>
                          <Image
                            src={
                              !twoSelected
                                ? "/Images/faces/medium.jpg"
                                : "/Images/faces/mediumSel.jpg"
                            }
                            style={{ height: 30 }}
                          />
                        </th>
                        <th style={{ textAlign: "center" }}>
                          <Image
                            src={
                              !threeSelected
                                ? "/Images/faces/poor.jpg"
                                : "/Images/faces/poorSel.jpg"
                            }
                            style={{ height: 30 }}
                          />
                        </th>
                        <th style={{ textAlign: "center" }}>
                          <Image
                            src={
                              !fourSelected
                                ? "/Images/faces/verybad.jpg"
                                : "/Images/faces/verybadSel.jpg"
                            }
                            style={{ height: 30 }}
                          />
                        </th>
                        <th style={{ textAlign: "center" }}>
                          <Image
                            src={
                              !fiveSelected
                                ? "/Images/faces/highlybad.jpg"
                                : "/Images/faces/highlybadSel.jpg"
                            }
                            style={{ height: 30 }}
                          />
                        </th>
                      </tr>
                      <tr>
                        <th style={{ textAlign: "center" }}>
                          <Button
                            color="default"
                            variant="text"
                            disabled={
                              idSesion > 0
                                ? estatusHojaEnf === "Finalizada"
                                  ? true
                                  : false
                                : true
                            }
                            onClick={() =>
                              handleEscalasSelected({
                                opc: 0,
                                upd: 1,
                              })
                            }
                          >
                            0
                          </Button>
                        </th>
                        <th style={{ textAlign: "center" }}>
                          <Button
                            disabled={
                              idSesion > 0
                                ? estatusHojaEnf === "Finalizada"
                                  ? true
                                  : false
                                : true
                            }
                            color="default"
                            variant="text"
                            onClick={() =>
                              handleEscalasSelected({
                                opc: 1,
                                upd: 1,
                              })
                            }
                          >
                            1
                          </Button>
                        </th>
                        <th style={{ textAlign: "center" }}>
                          <Button
                            disabled={
                              idSesion > 0
                                ? estatusHojaEnf === "Finalizada"
                                  ? true
                                  : false
                                : true
                            }
                            color="default"
                            variant="text"
                            onClick={() =>
                              handleEscalasSelected({
                                opc: 2,
                                upd: 1,
                              })
                            }
                          >
                            2
                          </Button>
                        </th>
                        <th style={{ textAlign: "center" }}>
                          <Button
                            disabled={
                              idSesion > 0
                                ? estatusHojaEnf === "Finalizada"
                                  ? true
                                  : false
                                : true
                            }
                            color="default"
                            variant="text"
                            onClick={() =>
                              handleEscalasSelected({
                                opc: 3,
                                upd: 1,
                              })
                            }
                          >
                            3
                          </Button>
                        </th>
                        <th style={{ textAlign: "center" }}>
                          <Button
                            disabled={
                              idSesion > 0
                                ? estatusHojaEnf === "Finalizada"
                                  ? true
                                  : false
                                : true
                            }
                            color="default"
                            variant="text"
                            onClick={() =>
                              handleEscalasSelected({
                                opc: 4,
                                upd: 1,
                              })
                            }
                          >
                            4
                          </Button>
                        </th>
                        <th style={{ textAlign: "center" }}>
                          <Button
                            disabled={
                              idSesion > 0
                                ? estatusHojaEnf === "Finalizada"
                                  ? true
                                  : false
                                : true
                            }
                            color="default"
                            variant="text"
                            onClick={() =>
                              handleEscalasSelected({
                                opc: 5,
                                upd: 1,
                              })
                            }
                          >
                            5
                          </Button>
                        </th>
                      </tr>
                    </thead>
                  </Table>
                </div>
              </div>
              <div className="row mb-2">
                <div className="col">
                  <TextArea
                    disabled={idSesion > 0 ? false : true}
                    rows={2}
                    value={observa}
                    placeholder="Observaciones"
                    onBlur={(e) =>
                      updateCampo("observa", {
                        target: {
                          value: e.target.value,
                        },
                      })
                    }
                    style={{
                      backgroundColor: "#E7FBFE",
                    }}
                    onChange={(e) => handleObserva(e)}
                  />
                </div>
              </div>
              <div className="row mb-1">
                {imageFirmaEnf && (
                  <div className="text-center col-lg-6 col-md-6 col-sm-6">
                    <img
                      src={imageFirmaEnf}
                      alt="signature"
                      style={{
                        height: "200px",
                        width: "auto",
                        padding: "10px",
                      }}
                    />
                  </div>
                )}
                {loadFirmaEnf && imageFirmaEnf === null && (
                  <div className="text-center col-lg-6 col-md-6 col-sm-6">
                    <img
                      src={`Unidades/${idNegocio}/Enfermeria/${idEnf}/${loadFirmaEnf}`}
                      alt="signature"
                      style={{
                        height: "200px",
                        width: "auto",
                        padding: "10px",
                      }}
                    />
                  </div>
                )}
                {imageFirmaPac && (
                  <div className="text-center col-lg-6 col-md-6">
                    <img
                      src={imageFirmaPac}
                      alt="signature"
                      style={{
                        height: "200px",
                        width: "auto",
                        padding: "10px",
                      }}
                    />
                  </div>
                )}
                {loadFirmaPac && imageFirmaPac === null && (
                  <div className="text-center col-lg-6 col-md-6">
                    <img
                      src={`Unidades/${idNegocio}/Sesiones/${idSesion}/FirmasHojaEnf/${loadFirmaPac}`}
                      alt="signature"
                      style={{
                        height: "200px",
                        width: "auto",
                        padding: "10px",
                      }}
                    />
                  </div>
                )}
              </div>
              <div className="row">
                <div className="text-center col-lg-6 col-md-6 col-sm-6">
                  <Text weight="semibold">{nombreUser}</Text>
                </div>
                <div className="text-center col-lg-6 col-md-6 col-sm-6">
                  <Text weight="semibold">{paciente}</Text>
                </div>
              </div>
              <div className="row">
                <div className="col-lg-6 col-md-6">
                  <Button
                    color="default"
                    variant="outlined"
                    disabled={idSesion > 0 ? false : true}
                    block
                    onClick={() => handleOpenModalFirma("Enfermero(a)")}
                  >
                    Firma de enfermero(a)
                  </Button>
                </div>
                <div className="col-lg-6 col-md-6">
                  <Button
                    color="default"
                    variant="outlined"
                    disabled={idSesion > 0 ? false : true}
                    block
                    onClick={() => handleOpenModalFirma("Paciente")}
                  >
                    Firma del paciente
                  </Button>
                </div>
              </div>
            </Splitter.Panel>
            <Splitter.Panel>
              <Box mb={5}>
                <Text weight="bold" size={isMobile ? "sm" : "md"}>
                  META INTERNACIONAL 4: LISTA DE VERIFICACIÓN PRE-PROCEDIMIENTO
                </Text>
              </Box>
              <Table key={`tblMeta`} bordered responsive size="md">
                <thead>
                  {dataVerificaProc.length > 0 ? (
                    dataVerificaProc.map((item, index) => (
                      <tr key={`${index}`}>
                        <th key={`cell-1-${index}`}>{item.NombrePreProc}</th>
                        <th key={`cell2-${index}`}>
                          <SelectPicker
                            block
                            searchable={false}
                            disabled={
                              estatusHojaEnf === "Finalizada" ? true : false
                            }
                            key={`picker-${index}`}
                            value={item.respuesta}
                            placeholder="-"
                            onChange={(e) => updateRespuesta(e, item.NoPreProc)}
                            data={
                              item.NoPreProc === 5
                                ? [
                                    { label: "FAV", value: "FAV" },
                                    { label: "CATÉTER", value: "CATÉTER" },
                                  ]
                                : item.NoPreProc < 10
                                  ? [
                                      { label: "SI", value: "SI" },
                                      { label: "NO", value: "NO" },
                                    ]
                                  : [
                                      { label: "Bajo", value: "Bajo" },
                                      {
                                        label: "Intermedio",
                                        value: "Intermedio",
                                      },
                                      { label: "Alto", value: "Alto" },
                                    ]
                            }
                          />
                        </th>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <th></th>
                    </tr>
                  )}
                </thead>
              </Table>
              <Box mb={5}>
                <Text weight="bold" size={isMobile ? "sm" : "md"}>
                  Determinación del grado de riesgo de caída al termino de
                  sesión.
                </Text>
              </Box>
              <Table
                key={`tblDetermina`}
                responsive
                size="sm"
                style={{ width: "90%" }}
              >
                <thead>
                  <tr>
                    <th>Nivel</th>
                    <th style={{ textAlign: "center" }}>Puntos</th>
                    <th style={{ textAlign: "center" }}>Marque cona una X</th>
                  </tr>
                  <tr>
                    <th>Alto riesgo</th>
                    <th style={{ textAlign: "center" }}>4-10</th>
                    <th style={{ textAlign: "center" }}>
                      <Checkbox
                        bordered
                        checked={gradoRiesgo === 4 ? true : false}
                        onClick={(e) => handleChecked(e.target.checked, 4)}
                        disabled={
                          idSesion > 0
                            ? estatusHojaEnf === "Finalizada"
                              ? true
                              : false
                            : true
                        }
                      />
                    </th>
                  </tr>
                  <tr>
                    <th>Mediano</th>
                    <th style={{ textAlign: "center" }}>2-3</th>
                    <th style={{ textAlign: "center" }}>
                      <Checkbox
                        bordered
                        checked={gradoRiesgo === 2 ? true : false}
                        onClick={(e) => handleChecked(e.target.checked, 2)}
                        disabled={
                          idSesion > 0
                            ? estatusHojaEnf === "Finalizada"
                              ? true
                              : false
                            : true
                        }
                      />
                    </th>
                  </tr>
                  <tr>
                    <th>Bajo</th>
                    <th style={{ textAlign: "center" }}>0-1</th>
                    <th style={{ textAlign: "center" }}>
                      <Checkbox
                        bordered
                        checked={gradoRiesgo === 0 ? true : false}
                        onClick={(e) => handleChecked(e.target.checked, 0)}
                        disabled={
                          idSesion > 0
                            ? estatusHojaEnf === "Finalizada"
                              ? true
                              : false
                            : true
                        }
                      />
                    </th>
                  </tr>
                </thead>
              </Table>
            </Splitter.Panel>
          </Splitter>
        </div>

        {/* >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> MODAL INICIO DE SESION <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<< */}
        <Modal
          size={"sm"}
          open={openModalInicia}
          onClose={handleCloseModalInicia}
        >
          <Modal.Header>
            <Modal.Title>Inicio de la Hoja de Enfermería</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Panel>
              <div className="row mb-3">
                <div className="col">
                  <Text weight="semibold" size={"xxl"}>
                    ¿Desea iniciar la sesión del paciente? <br></br>
                    {paciente}
                  </Text>
                </div>
              </div>
              <div className="row">
                <div className="col">
                  {filtroAsignado ? (
                    ""
                  ) : (
                    <>
                      <Text size={"md"}>Filtro</Text>
                      <SelectPicker
                        data={listInvent}
                        block
                        value={idEntrada}
                        onChange={(e) => setIdEntrada(e)}
                        placeholder="--SELECCIONA--"
                      />
                    </>
                  )}
                </div>
              </div>
              <div className="row">
                <div className="col">
                  <Text size={"md"} color={"red"}>
                    * Para grabar información en la hoja: <br></br>
                    Debes ingresar al campo y presionar la tecla <b>Tab</b>
                  </Text>
                </div>
              </div>
            </Panel>
          </Modal.Body>
          <Modal.Footer>
            <Button
              icon={<DoorClosed></DoorClosed>}
              color="default"
              variant="solid"
              onClick={handleCloseModalInicia}
            >
              Cerrar
            </Button>
            <Button
              icon={<Check></Check>}
              type="primary"
              onClick={handleDatosPaciente}
              disabled={idEntrada !== 0 || filtroAsignado ? false : true}
              loading={loadingInicio}
            >
              Inciar
            </Button>
          </Modal.Footer>
        </Modal>

        {/* >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> MODAL SEROLOGIA <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<< */}
        <Modal
          size={"xs"}
          open={openModalSerolog}
          onClose={handleCloseModalSerolog}
        >
          <Modal.Header>
            <Modal.Title>Serología Positiva</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Panel>
              <div className="row">
                <div className="col">
                  <Text>Selecciona una opción</Text>
                  <SelectPicker
                    block
                    placeholder="-"
                    searchable={false}
                    value={seroPositiva}
                    data={[
                      { label: "Hepatitis B", value: "Hepatitis B" },
                      { label: "Hepatitis C", value: "Hepatitis C" },
                      { label: "VIH", value: "VIH" },
                    ]}
                    onChange={(e) => handleSeroPositiva(e)}
                  />
                </div>
              </div>
            </Panel>
          </Modal.Body>
        </Modal>

        {/* >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> MODAL SEGUIMIENTO <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<< */}
        <Modal
          size={"sm"}
          open={openModalSeg}
          onClose={handleCloseModalSeg}
          backdrop="static"
          keyboard="true"
        >
          <Modal.Header>
            <Modal.Title>Seguimiento - Hora: {horaSeg}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Panel bordered>
              <Form
                name="basic"
                form={form}
                labelCol={{ span: 4 }}
                wrapperCol={{ span: 14 }}
                layout="horizontal"
                variant="outlined"
                initialValues={{ remember: true }}
                onFinish={addSeguimiento}
                onFinishFailed={onFinishFailed}
                autoComplete="off"
                validateMessages={validateMessages}
              >
                <Form.Item
                  name="temp"
                  label="TEMP"
                  rules={[{ required: true }]}
                >
                  <InputNumber
                    maxLength={5}
                    min={0}
                    onFocus={handleFocus}
                    onClick={handleFocus}
                    controls={false}
                    style={{
                      textAlign: "center",
                      width: "100%",
                      backgroundColor: "#E7FBFE",
                    }}
                  />
                </Form.Item>

                <Form.Item name="fc" label="F.C" rules={[{ required: true }]}>
                  <InputNumber
                    onFocus={handleFocus}
                    onClick={handleFocus}
                    maxLength={5}
                    style={{
                      textAlign: "center",
                      width: "100%",
                      backgroundColor: "#E7FBFE",
                    }}
                    min={0}
                    controls={false}
                  />
                </Form.Item>

                <Form.Item name="fr" label="F.R" rules={[{ required: true }]}>
                  <InputNumber
                    maxLength={5}
                    style={{
                      textAlign: "center",
                      width: "100%",
                      backgroundColor: "#E7FBFE",
                    }}
                    min={0}
                    controls={false}
                    onFocus={handleFocus}
                    onClick={handleFocus}
                  />
                </Form.Item>

                <Form.Item name="ta" label="TA" rules={[{ required: true }]}>
                  <Input
                    maxLength={8}
                    style={{
                      textAlign: "center",
                      width: "100%",
                      backgroundColor: "#E7FBFE",
                    }}
                    controls={false}
                    onFocus={handleFocus}
                    onClick={handleFocus}
                  />
                </Form.Item>

                <Form.Item name="fd" label="FD" rules={[{ required: true }]}>
                  <InputNumber
                    maxLength={5}
                    style={{
                      textAlign: "center",
                      width: "100%",
                      backgroundColor: "#E7FBFE",
                    }}
                    min={0}
                    controls={false}
                    onFocus={handleFocus}
                    onClick={handleFocus}
                  />
                </Form.Item>

                <Form.Item name="fs" label="FS" rules={[{ required: true }]}>
                  <InputNumber
                    maxLength={5}
                    style={{
                      textAlign: "center",
                      width: "100%",
                      backgroundColor: "#E7FBFE",
                    }}
                    min={0}
                    controls={false}
                    onFocus={handleFocus}
                    onClick={handleFocus}
                  />
                </Form.Item>

                <Form.Item name="pv" label="PV" rules={[{ required: true }]}>
                  <InputNumber
                    maxLength={5}
                    style={{
                      textAlign: "center",
                      width: "100%",
                      backgroundColor: "#E7FBFE",
                    }}
                    min={0}
                    controls={false}
                    onFocus={handleFocus}
                    onClick={handleFocus}
                  />
                </Form.Item>

                <Form.Item name="tmp" label="TMP" rules={[{ required: true }]}>
                  <InputNumber
                    maxLength={5}
                    style={{
                      textAlign: "center",
                      width: "100%",
                      backgroundColor: "#E7FBFE",
                    }}
                    min={0}
                    controls={false}
                    onFocus={handleFocus}
                    onClick={handleFocus}
                  />
                </Form.Item>

                <Form.Item name="na" label="NA" rules={[{ required: true }]}>
                  <InputNumber
                    maxLength={5}
                    style={{
                      textAlign: "center",
                      width: "100%",
                      backgroundColor: "#E7FBFE",
                    }}
                    min={0}
                    controls={false}
                    onFocus={handleFocus}
                    onClick={handleFocus}
                  />
                </Form.Item>

                <Form.Item name="uf" label="UF" rules={[{ required: true }]}>
                  <InputNumber
                    maxLength={5}
                    style={{
                      textAlign: "center",
                      width: "100%",
                      backgroundColor: "#E7FBFE",
                    }}
                    min={0}
                    controls={false}
                    onFocus={handleFocus}
                    onClick={handleFocus}
                  />
                </Form.Item>

                <Form.Item label={null}>
                  <Button type="primary" htmlType="submit" block>
                    Guardar
                  </Button>
                </Form.Item>
              </Form>
            </Panel>
          </Modal.Body>
        </Modal>

        {/* >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> MODAL ADD INSUMOS <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<< */}
        <ModalInsumos
          ref={modal}
          idNegocio={idNegocio}
          openInsumos={openModalMedics}
          idUser={idUser}
          idSesion={idSesion}
          paciente={paciente}
        />

        {/* >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> MODAL FIRMAS <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<< */}
        <Modal
          size={"md"}
          open={openModalFirma}
          onClose={handleCloseModalFirma}
        >
          <Modal.Header>
            <Modal.Title>Firma del {dataFirma}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Panel bordered>
              <SignatureCanvas
                ref={signCanvas}
                canvasProps={{
                  style: { width: "100%", minHeight: "376px" },
                }}
              />
            </Panel>
          </Modal.Body>
          <Modal.Footer>
            <Button
              icon={<Eraser></Eraser>}
              color="default"
              variant="solid"
              onClick={clear}
            >
              Borrar
            </Button>
            <Button
              icon={<Save size={16}></Save>}
              type="primary"
              onClick={
                dataFirma === "Paciente" ? saveSignaturePac : saveSignature
              }
            >
              Guardar
            </Button>
          </Modal.Footer>
        </Modal>
      </LayoutHome>
    </>
  );
};
